import { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import colors from '@/config/colors';
import { GestureButton } from '../GestureButton';

const styles = StyleSheet.create({
  container: {
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ffff',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },
  text: {
    color: '#3a3a3a',
    textAlign: 'center',
    verticalAlign: 'auto',
  },
  wrongBg: {
    backgroundColor: colors.red,
  },
  lightColor: {
    color: colors.lightGrey,
  },
  correctBg: {
    backgroundColor: colors.primary,
  },
  hidden: {
    opacity: 0,
  },
});

export function ClickableWordSquare({
  currentOrder,
  order,
  word,
  extraStyle,
  id,
  onCorrect,
  onWrong,
  isHidden,
  onWrongParam,
  fontSize,
  margin,
  wrongBoxChosen,
}) {
  const [isWrong, setIsWrong] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [showHint, setShowHint] = useState(false);

  const responsiveStylesForWord = StyleSheet.create({
    choiceWrapper: {
      paddingHorizontal: margin,
      marginBottom: margin,
    },
    choiceText: {
      fontSize: fontSize,
    },
  });

  const onWrongClick = () => {
    setIsWrong(true);
    setTimeout(() => {
      setIsWrong(false);
    }, 500);
    onWrong(onWrongParam);
  };

  const onCorrectClick = () => {
    setIsCorrect(true);
    setShowHint(false);
    onCorrect(id, currentOrder, word);
  };

  const onClick = () => {
    if (isHidden) return;
    if (order === -1 || order !== currentOrder) return onWrongClick();
    if (order === currentOrder) onCorrectClick();
  };

  useEffect(() => {
    if (wrongBoxChosen >= 2) {
      if (order === -1 || order !== currentOrder) {
        return;
      }
      if (order === currentOrder) {
        setShowHint(true);
      }
    }
  }, [wrongBoxChosen]);

  if (isHidden) {
    return (
      <View
        style={[
          styles.container,
          extraStyle,
          responsiveStylesForWord.choiceWrapper,
          styles.hidden,
        ]}
      >
        <Text
          className="font-abz"
          style={[
            styles.text,
            (isWrong || isCorrect) && styles.lightColor,
            responsiveStylesForWord.choiceText,
          ]}
        >
          {word}
        </Text>
      </View>
    );
  }

  return (
    <GestureButton onPress={onClick}>
      <View
        style={[
          styles.container,
          extraStyle,
          isWrong && styles.wrongBg,
          (showHint || isCorrect) && styles.correctBg,
          responsiveStylesForWord.choiceWrapper,
        ]}
      >
        <Text
          className="font-abz"
          style={[
            styles.text,
            (isWrong || isCorrect || showHint) && styles.lightColor,
            responsiveStylesForWord.choiceText,
          ]}
        >
          {word}
        </Text>
      </View>
    </GestureButton>
  );
}
